import { SafeHtml } from '@angular/platform-browser';
import { DynamicFormControl } from 'src/app/feature/dynamic-form/input/dynamic-form-control';

export enum ClickType {
	OK = 'OK',
	CANCEL = 'CANCEL',
}

export enum NotificationType {
	GENERAL = 'GENERAL',
	CONFIRM = 'CONFIRM',
}

export interface Notification {
	id?: string | number;
	initiator?: string;
	inputField?: DynamicFormControl<any>;
	dialogType: NotificationType;
	buttonLabel: string | SafeHtml;
	buttonLabelCancel?: string | SafeHtml;
	buttonColor?: string;
	buttonColorCancel?: string;
	hideCancelButton?: boolean;
	onClose?: (clicked: ClickType, inputData?: any) => void;
	title?: string;
	message: string;
}

export interface NotificationState {
	notifications: Notification[];
	current: Notification;
}

export const initialState: NotificationState = {
	notifications: [],
	current: null,
};
